/**
 * Test Environment Configuration
 * Students and Lecturers Portal - Angular 21
 * Generated by Azure DevOps Pipeline
 */

export const environment = {
  production: false,
  name: 'test',

  // Aetheris Backend URLs (Test Environment - Azure Front Door)
  api: {
    authUrl: 'https://api-test.vantage.ch',
    apiUrl: 'https://api-test.vantage.ch',
    translationUrl: 'https://api-test.vantage.ch',
  },

  // External Authentication Service URL (Test OIDC Provider)
  extAuthUrl: 'https://api-test.vantage.ch',

  // OIDC Client Configuration
  oidc: {
    clientId: 'openolat-client',
    clientSecret: 'supersecret',
    scope: 'openid profile email',
    redirectUri: 'https://test-portal.vantage.ch/auth/callback',
  },

  // Feature Flags (More logging for test)
  features: {
    enableLogging: true,
    enableDetailedErrors: true,
  },

  // Debug Mode (Enabled for test)
  debug: true,
};
